export default {
    getSessionInformation: function () {
        return JSON.parse(window.$gwtBridge.getSessionInformation());
    },
    getConfigurations: function () {
        return JSON.parse(window.$gwtBridge.getConfigurations());
    },
    getWorkplaces: function () {
        return JSON.parse(window.$gwtBridge.getWorkplaces());
    },
    getDepartments: function () {
        return JSON.parse(window.$gwtBridge.getDepartments());
    },
    getProjects: function () {
        return JSON.parse(window.$gwtBridge.getProjects());
    },
    downloadFile: function (url, fileName) {
        window.$gwtBridge.downloadFile(url, fileName);
    },
    isApp: function () {
        return window.$gwtBridge.isApp();
    },
	////////////////////////////////////////////////////////////////////////////
	// VALIDATION UTILS
	validateCIF: function (value) {
		return window.$gwtBridge.validateCIF(value);
	},
	validatePhone: function (value) {
		return window.$gwtBridge.validatePhone( value);
	},
	validatePostalCode: function (value) {
		return window.$gwtBridge.validatePostalCode(value);
	},
    validateDecimalSeparator: function (value) {
        return window.$gwtBridge.validateDecimalSeparator(value);
    }
	////////////////////////////////////////////////////////////////////////////

}